import React, { useEffect } from 'react';
import Popup from 'reactjs-popup';
import { Link } from 'react-router-dom';

const DataModelPopup = ({ openModal, setOpen, title, bodyData, children, sourceUrl }) => {
   
    const closeModal = () => {
        setOpen(false);
    };
    const handleBodyLock = (isLocked) => {
        if (isLocked) {
            document.body.classList.add('overflow-hidden');
        } else if (children !== true) {
            document.body.classList.remove('overflow-hidden');
        }
    };
    useEffect(() => {
        handleBodyLock(openModal);
        
        return () => {
            handleBodyLock(false);
        };
    }, [openModal]);
    return (
        <div>
            <Popup open={openModal} closeOnDocumentClick nested={true} onClose={closeModal} lockScroll={true} className={`data-modal ${children === true ? 'child-popup' : ''}`} >
                <div className="modal">
                    <div className="modal-header">
                        <Link onClick={closeModal}>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M22.0003 13.0001L22.0004 11.0002L5.82845 11.0002L9.77817 7.05044L8.36396 5.63623L2 12.0002L8.36396 18.3642L9.77817 16.9499L5.8284 13.0002L22.0003 13.0001Z"></path></svg>
                        </Link>
                        {sourceUrl && (

                            <Link className='sng-pop-link' to={sourceUrl} target="_blank">
                                <span>Open in a new window</span>
                                <i className="ri-external-link-line"></i>
                            </Link>
                        )}
                    </div>
                    <div className="modal-content table-modal-list">
                        <div className="list-table connection-pp-list list-overflow">
                            {bodyData}
                        </div>
                    </div>
                </div>
            </Popup>
        </div>
    );
};
export default DataModelPopup;